export const mockPostCreditRequestData = {
  isG3: 'true',
  recordLocator: '123',
  flightDate: '2023/01/13 12:30:00',
  partnerAirLine: 'SMILES',
  firstNameTicket: 'RONALDO',
  lastNameTicket: 'SILVA',
  electronicTicketNumber: '123',
  electronicTicketUrl: '123',
  flightList: [
    {
      flightDate: '2023/01/13 12:30:00',
      fligthNumber: '456',
      departureAirport: {
        name: 'GIG',
        code: '45',
        city: 'RJ',
        country: 'RJ',
      },
      arrivalAirport: {
        name: 'CGN',
        code: '56',
        city: 'SP',
        country: 'SP',
      },
      travelClass: 'ECONOMY',
      bookingClass: 'ECONOMY',
      boardingPassUrl: '',
    },
  ],
};
